import type { ExportColumnKeys } from "@/modules/export";
import type { UsersColumnKey } from "./users.types";

/** Coluna da tela de Usuários → chave do core na exportação (`null`: fora do arquivo; Foto e Ações). */
export const USERS_EXPORT_COLUMN_KEYS: ExportColumnKeys<UsersColumnKey> = {
  foto: null,
  nome: "nome",
  email: "email",
  time: "time",
  papel: "perfil",
  ultimaAtividade: "ultimaAtividade",
  status: "status",
  acoes: null,
};
